export default __webpack_public_path__ + "static/media/@flaamorais.aa4469ac.jpg";